module.exports = __webpack_public_path__ + "img/avatar_default.8ee00339.png";